export default require('rde-view-common/locales/labels_en.json');
